import { SelectOption } from '@/components/Form'
import { CommunityBasedTrainingPatientEnum } from './CommunityBasedTrainingPatientEnum'

const Type: SelectOption[] = [
  {
    value: CommunityBasedTrainingPatientEnum.VisitType.Prescription,
    label: 'Prescription (P)'
  },
  {
    value: CommunityBasedTrainingPatientEnum.VisitType.Investigation,
    label: 'Investigation (I)'
  },

  {
    value: CommunityBasedTrainingPatientEnum.VisitType.Referral,
    label: 'Referral (R)'
  }
]
export const CommunityBasedTrainingPatientOption = { Type }
